import { gql } from "@apollo/client";

export const INSERT_RESERVATION = gql`
    mutation gqlInsertBook($book: BookInput!) {
        code: gqlInsertBook(book: $book)
    }
`;

export const UPDATE_RESERVATION = gql`
    mutation gqlUpdateBook($nID: Int!, $nIDUser: Int!, $nIDRestaurant: Int!, $book: BookInput!) {
        code: gqlUpdateBook(nID: $nID, nIDUser: $nIDUser, nIDRestaurant: $nIDRestaurant, book: $book)
    }
`;

export const DELETE_RESERVATION = gql`
    mutation gqlDeleteBook($nID: Int!, $nIDUser: Int!, $nIDRestaurant: Int!) {
        code: gqlDeleteBook(nID: $nID, nIDUser: $nIDUser, nIDRestaurant: $nIDRestaurant)
    }
`;

export const UPDATE_STATUS_RESERVATION = gql`
    mutation gqlUpdateStatusOfBooking($nID: Int!, $nIDRestaurant: Int!, $nIDUser: Int!, $nStatus: Int!) {
        code: gqlUpdateStatusOfBooking(nID: $nID, nIDRestaurant: $nIDRestaurant, nIDUser: $nIDUser, nStatus: $nStatus)
    }
`;